import { createAction } from '@reduxjs/toolkit';

export const addNewTopLevelAssignment = createAction(
  'projectEdit/addNewTopLevelAssignment'
);

export const addNewChildAssignment = createAction(
  'projectEdit/addNewChildAssignment'
);
